
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'HelpIcon',
  components: {},
  setup() {
    return {
      showHelp: ref(false),
    };
  },
});
